import team1 from "../../assets/team1.webp";
import team2 from "../../assets/team2.webp";
import team3 from "../../assets/team3.webp";

const teamData = [
  {
    id: 1,
    img: team1,
    alt: "Photo of the fitness coach - John Carter.",
    name: "John Carter",
  },
  {
    id: 2,
    img: team2,
    alt: "Photo of the personal trainer - Emily Brown.",
    name: "Emily Brown",
  },
  {
    id: 3,
    img: team3,
    alt: "Photo of the fitness expert - Michael Green.",
    name: "Michael Green",
  },
];

export default teamData;
